var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Divider, RowLayout, styled, Text } from '@auth0/quantum-product';
import * as React from 'react';
import { getCurrentLanguage } from '../../../../lib/i18n';
import NavigationStore from '../../../stores/NavigationStore';
import { useFluxible } from '../../hooks/useFluxible';
import { useTranslation } from '../../hooks/useTranslation';
import { ContentContainer } from '../../layouts';
import { NavCards } from '../../NavCard';
import TutorialNavigator from '../../quickstarts/TutorialNavigator';
import { TutorialBackground } from '../../quickstarts/TutorialNavigator/TutorialBackground';
import { SearchBox } from '../../SearchBox/SearchBox';
import { SectionPipeline } from '../../SectionPipeline';
var TopFold = styled(RowLayout)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.palette.mode === 'light' ? theme.palette.background.homePage : 'inherit',
        borderBottom: theme.palette.mode === 'dark' ? "1px solid ".concat(theme.tokens.color_border_default) : 'none',
        paddingTop: theme.spacing(8),
        borderBottomLeftRadius: theme.spacing(5),
        borderBottomRightRadius: theme.spacing(5),
        position: 'relative',
        marginBottom: theme.spacingPX(8) + 120,
    });
});
var Background = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            position: 'absolute',
            right: 0,
            bottom: 0,
            display: 'flex',
            overflow: 'hidden',
            borderBottomRightRadius: theme.spacing(5)
        },
        _b[theme.breakpoints.down(theme.layout.homePageDesktopBreakpoint)] = {
            left: 0,
            borderBottomLeftRadius: theme.spacing(5),
            '& svg': {
                width: '100%',
            },
        },
        _b);
});
export var HomePage = function (props) {
    var supportedLocales = ['fr-ca', 'ja-jp'];
    var context = useFluxible();
    var navigationStore = context.getStore(NavigationStore);
    var navigationItems = navigationStore.getNavigationItems('articles');
    var urlLocale = typeof window !== 'undefined' ? window.location.pathname.split('/')[2] : 'en-us';
    var locale = supportedLocales.includes(urlLocale) ? urlLocale.toLowerCase() : 'en-us';
    var currentLanguage = getCurrentLanguage();
    var filteredItems = (navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.filter(function (navItem) {
        if (locale === 'en-us') {
            // Return items that do not include any supported locale in the URL
            return !supportedLocales.some(function (supportedLocale) { return navItem.url.includes("/".concat(supportedLocale, "/")); });
        }
        else {
            // Return items that include the specific locale in the URL
            return navItem.url.includes("/".concat(locale, "/"));
        }
    })) || [];
    var t = useTranslation('core').t;
    return (React.createElement(React.Fragment, null,
        React.createElement(TopFold, { id: "maincontent", role: "main", gutter: 8 },
            React.createElement(SearchBox, { placement: "homepage", placeholder: t('pages.homePage.searchPlaceholder', 'Search the docs') }),
            React.createElement(TutorialNavigator, __assign({ largeHeader: true, firstQuestion: t('pages.homePage.startBuilding', 'Start Building'), subHeader: t('pages.homePage.chooseApplicationType', 'Choose your application type to get started'), onHomePage: true, locale: currentLanguage === '' ? 'en-us' : currentLanguage }, props)),
            React.createElement(Background, null,
                React.createElement(TutorialBackground, null))),
        React.createElement(ContentContainer, { gutter: 5 },
            React.createElement(Text, { variant: "h1", component: "h1" }, t('pages.homePage.learnAboutAuth0', 'Learn about Auth0')),
            React.createElement(SectionPipeline, { active: "All", locale: locale }),
            React.createElement(Text, { variant: "h4", sx: { fontWeight: 'regular' }, color: "textSecondary" }, t('pages.homePage.auth0Description', 'Rely on the Auth0 identity platform to add sophisticated authentication and authorization to your applications. Centralize and manage users from multiple identity providers and give them branded, seamless signup and login experiences. Finely control access with a degree of customization that can accommodate even the most complex security requirements.')),
            React.createElement(Divider, { orientation: "horizontal" }),
            React.createElement(NavCards, { items: filteredItems }))));
};
